import styled from 'styled-components';

const AvatarEditorContainer = styled.div`
  margin-bottom: 20px;
`;

export const Styled = {
  AvatarEditorContainer,
};
